import EL, { HTMLELEMENT } from '../../EL/EL.js';
import CITE from '../../DOM/cite/CITE.js';
import TEXT from '../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const footerAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const footerData = makeDataStruct([]);
export const footerModel = makeStruct([
    ['attributes', footerAttr],
    ['data', footerData]
]);
// Simplified Model
export function footer(className) {
    return {
        attributes: footerAttr(className),
        data: footerData()
    };
}
/** A generic footer that should be placed at the bottom of content */
export default class FOOTER extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.FOOTER, model);
    }
    /** Adds a Cite to this element	*/
    addCite(model) {
        return this.addChild(new CITE(this, model));
    }
}
export { CITE, EL };
